import { FC, useState } from 'react'

import {
  TableFooter,
  TableBodyStyled,
  TableCellStyled,
  TableContainerStyled,
  TableHeadStyled,
  TableRowStyled,
  TableStyled
} from 'components'
import { DeleteIcon, EditIcon } from 'components/Icons'
import { RolDocumento } from 'services/NGT/Parameterization'

import { TypeAction } from '../../RollDocuments'

interface ITableRollDocuments {
  tableData: RolDocumento[]
  handleSelectRolDoc: (row: RolDocumento, typeAction: TypeAction) => void
  handleChangePage: (newPage: number) => void
  page: number
  rowsPerPage: number
  handleChangeRowsPerPage: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void
}
export const TableRollDocuments: FC<ITableRollDocuments> = ({
  tableData,
  handleSelectRolDoc,
  handleChangePage,

  page,
  rowsPerPage,
  handleChangeRowsPerPage
}) => {
  return (
    <>
      <TableContainerStyled>
        <TableStyled>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled align="left" minwidth="60px">
                Item
              </TableCellStyled>
              <TableCellStyled align="left" minwidth="60px">
                Rol
              </TableCellStyled>
              <TableCellStyled align="left" minwidth="160px">
                Pendência
              </TableCellStyled>
              <TableCellStyled align="left">Tipo</TableCellStyled>
              <TableCellStyled align="left">Descrição</TableCellStyled>
              <TableCellStyled align="left" minwidth="96px">
                Tipo Efetivo
              </TableCellStyled>
              <TableCellStyled align="left" minwidth="96px">
                Status
              </TableCellStyled>
              <TableCellStyled align="left" minwidth="165px">
                Cálculo Risco
              </TableCellStyled>
              <TableCellStyled align="left">Índice</TableCellStyled>
              <TableCellStyled align="left" minwidth="136px">
                Ações
              </TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled>
            {(rowsPerPage > 0
              ? tableData?.slice(
                  page * rowsPerPage,
                  page * rowsPerPage + rowsPerPage
                )
              : tableData
            )?.map((row, index) => (
              <TableRowStyled key={`${index}-${row.idRolDocumento}`}>
                <TableCellStyled align="left">{row.nuItem}</TableCellStyled>
                <TableCellStyled align="left">
                  {row.txtTipoDocumento}
                </TableCellStyled>
                <TableCellStyled>{row.descPendencia}</TableCellStyled>
                <TableCellStyled align="left">
                  {row.tipoPendencia}
                </TableCellStyled>
                <TableCellStyled>{row.txtDescDocumento}</TableCellStyled>
                <TableCellStyled align="left">
                  {row.cdTipoEfetivo}
                </TableCellStyled>
                <TableCellStyled align="left">
                  {row.cdStatusEfetivo}
                </TableCellStyled>
                <TableCellStyled>{row.cdCalcRisco}</TableCellStyled>
                <TableCellStyled align="left">{row.nuIndice}</TableCellStyled>
                <TableCellStyled align="left">
                  <EditIcon
                    cursor="pointer"
                    onClick={() => handleSelectRolDoc(row, 'edit')}
                  />
                  <DeleteIcon
                    cursor="pointer"
                    onClick={() => handleSelectRolDoc(row, 'delete')}
                  />
                </TableCellStyled>
              </TableRowStyled>
            ))}
          </TableBodyStyled>
        </TableStyled>
      </TableContainerStyled>
      <TableFooter
        page={page}
        rows={tableData}
        rowsPerPage={rowsPerPage}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        typeFooter="offline"
      />
    </>
  )
}
